module.exports = __webpack_public_path__ + "img/btn_betsize.9fd6821c.png";